module.exports = __webpack_public_path__ + "r-v3/img/ml_33_00.fb1b5a90.jpg";